import React from "react";
import { DropDownMenu, MenuItem } from "material-ui";

import Label from "./label.jsx";
import QuantityEditor from "./quantity-editor.jsx";

const INTERVALS = ["day", "week", "month", "year"];

class RecurrenceField extends React.Component {
  constructor(props) {
    super(props);
    this._makeIntervalItems = this._makeIntervalItems.bind(this);
  }

  _makeIntervalItems() {
    const count = this.props.value[0];
    return INTERVALS.map((item, i) => (
      <MenuItem
        key={i}
        primaryText={`${item}${count !== 1 ? "s" : ""}`}
        value={item}
        style={{ cursor: "pointer" }}
      />
    ));
  }

  render() {
    let { value, label, ...props } = this.props,
      [count, interval] = value;

    return (
      <div {...props}>
        {label || "Repeat every"}
        <QuantityEditor
          min={1}
          style={{ display: "inline-block" }}
          quantity={count}
          updateQuantity={q => this.props.onChange([q, interval])}
        />
        <DropDownMenu
          value={interval}
          onChange={(e, index, value) => this.props.onChange([count, value])}
        >
          {this._makeIntervalItems()}
        </DropDownMenu>
      </div>
    );
  }
}

export default RecurrenceField;



// WEBPACK FOOTER //
// ./src/app/components/partials/recurrence-field.jsx